import { InjectionToken } from '@angular/core';

export const RECAPTCHA_OVERRIDE_TOKEN = new InjectionToken<string>(
  'override recaptcha token injection token'
);
